import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideIdentityVerificationHandler } from '@core/store/profile/profile.providers';
import { provideAnalytics } from '@core/services/analytics/analytics.providers';
import {
  provideCvScreeningHandlers,
  provideNotificationCreatedHandler,
  providePostulationsUpdateHandler,
  provideVideoInterviewProgressHandler,
  provideVideoInterviewTerminalHandler,
} from '@core/store/notifications/notifications.providers';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule, PERSISTENCE } from '@angular/fire/compat/auth';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { NgxsModule, Store } from '@ngxs/store';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { TuiRootModule, TuiDialogModule, TuiAlertModule } from '@taiga-ui/core';
import { TuiPdfViewerModule } from '@taiga-ui/kit';
import { TUI_LANGUAGE, TUI_SPANISH_LANGUAGE } from '@taiga-ui/i18n';
import { of } from 'rxjs';
import { ChunkLoadErrorHandler } from '@core/services/chunk-load-error.handler';
import { AppointmentGateInterceptor } from '@core/security/interceptors/appointment-gate.interceptor';
import { AuthTokenInterceptor } from '@core/security/interceptors/auth-token.interceptor';
import { ToastContainerComponent } from '@shared/components/toast-container/toast-container.component';
import { CoreModule } from './core/core.module';
import { DataModule } from './data/data.module';
import { environment } from '@env';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { appState } from './core/store';
import { initializeApp } from './app.initializer';
import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';

registerLocaleData(es);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    NgxsModule.forRoot(appState, { developmentMode: !environment.production }),
    NgxsReduxDevtoolsPluginModule.forRoot(),
    DataModule,
    CoreModule,
    AppRoutingModule,
    TuiRootModule,
    TuiDialogModule,
    TuiAlertModule,
    TuiPdfViewerModule,
    ToastContainerComponent,
  ],
  providers: [
    { provide: ErrorHandler, useClass: ChunkLoadErrorHandler },
    { provide: LOCALE_ID, useValue: 'es-MX' },
    { provide: TUI_LANGUAGE, useValue: of(TUI_SPANISH_LANGUAGE) },
    { provide: PERSISTENCE, useValue: 'local' },
    { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AppointmentGateInterceptor, multi: true },
    provideAnalytics(),
    provideIdentityVerificationHandler(),
    provideNotificationCreatedHandler(),
    providePostulationsUpdateHandler(),
    provideVideoInterviewProgressHandler(),
    ...provideVideoInterviewTerminalHandler(),
    ...provideCvScreeningHandlers(),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [Store],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
